import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiVideo, FiUsers, FiLock } from 'react-icons/fi';
import toast from 'react-hot-toast';

const CreateRoomCard = () => {
  const navigate = useNavigate();
  const [roomName, setRoomName] = useState('');

  const handleCreateRoom = () => {
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    const roomCode = Array.from({ length: 6 }, () => alphabet[Math.floor(Math.random() * alphabet.length)]).join('');
    if (roomName.trim()) {
      sessionStorage.setItem(`FutureLabGalaxy-classroom-${roomCode}`, roomName.trim());
    }
    toast.success('Classroom started');
    navigate(`/room/${roomCode}`);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition duration-300">
      <div className="h-2 bg-gradient-to-r from-blue-600 to-purple-600"></div>
      <div className="p-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Create Classroom
          </h2>
          <FiVideo className="text-4xl text-blue-600" />
        </div>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Start a live FutureLabGalaxy class instantly. Share the classroom code with students to join.
        </p>

        <div className="space-y-4 mb-6">
          <input
            type="text"
            placeholder="Classroom name (optional)"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
          
          <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
            <FiUsers />
            <span>Up to 50 participants</span>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
          <FiLock />
            <span>Classroom can be locked by teacher</span>
          </div>
        </div>

        <button
          onClick={handleCreateRoom}
          className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white py-3 rounded-lg font-semibold hover:from-emerald-700 hover:to-teal-700 transition"
        >
          Create Classroom & Start Teaching
        </button>
      </div>
    </div>
  );
};

export default CreateRoomCard;
